import { render, staticRenderFns } from "./PaginationSummary.vue?vue&type=template&id=59d80664&scoped=true"
import script from "./PaginationSummary.vue?vue&type=script&lang=js"
export * from "./PaginationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d80664",
  null
  
)

export default component.exports